import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

import { I18nPipe } from '../../../../shared/pipes/i18n.pipe';

@Component({
  selector: 'umkt-domain-authorization-confirmation-modal',
  standalone: true,
  imports: [CommonModule, I18nPipe],
  templateUrl: './domain-authorization-confirmation-modal.component.html',
  styleUrl: './domain-authorization-confirmation-modal.component.scss',
})
export class DomainAuthorizationConfirmationModalComponent {
  @Input() isOpen: boolean = false;
  @Input() domain: string = '';
  @Output() confirm = new EventEmitter<void>();

  onConfirm(): void {
    this.confirm.emit();
  }
}
